interface ColorsType {
    primary: string;
    spinner: string;
    skeleton: string;

    ntClrOne: string;
    ntClrTwo: string;
    ntClrThree: string;

    primaryLight: string;
    primaryDark: string;

    text: string;
    subHeading: string;
    heading: string;

    btnDark: string;
    btnDarkHover: string;
    btnDarkActive: string;

    btnGrayDark: string;
    btnGrayDarkHover: string;
    btnGrayDarkActive: string;

    letterSpacing: string;
    borderRadius: string;
}

export const colors: ColorsType = {
    primary: "#28A8EF",
    spinner: "#28A8EF",
    skeleton: "#ddd",

    // Neutral Colors
    ntClrOne: "#C9D3DE",
    ntClrTwo: "#F8F8FA",
    ntClrThree: "#F5F5F7",

    // Primary Palette
    primaryLight: "#76b9ee",
    primaryDark: "#1b69b4",

    // Text Colors
    text: "#3e4246",
    subHeading: "#212529",
    heading: "#0F1112",

    // Dark Button Colors
    btnDark: "#164b82",
    btnDarkHover: "#1e5d9f",
    btnDarkActive: "#123d6a",

    // Gray Button Colors
    btnGrayDark: "#2e3235",
    btnGrayDarkHover: "#3a3f42",
    btnGrayDarkActive: "#222628",

    // Values
    letterSpacing: "0.25px",
    borderRadius: "8px",
};
